import { msToTime } from '../../util';
import { StatesUserInput } from './index';
import VStack from 'components/VStack';

interface TimerDisplayProps {
  frames: number;
  userInputState: StatesUserInput;
}

interface TimerElementProps extends TimerDisplayProps {
  videoActive: boolean;
}

const BigTimer = ({ frames, userInputState }: TimerDisplayProps) => {
  const textClass =
    userInputState === StatesUserInput.Record ? 'activeText' : '';
  return (
    <div
      className={`notchSafe animate__animated animate__fadeInDown animate__faster ${textClass}`}
    >
      <VStack>
        <div>
          <span className="timerText">{msToTime(frames, 'seconds')}</span>
        </div>
        <div style={{ paddingTop: '-15px', paddingBottom: '15px' }}>
          <span className="timerText">{msToTime(frames, 'millis')}</span>
        </div>
      </VStack>
    </div>
  );
};

const SmallTimer = ({ frames, userInputState }: TimerDisplayProps) => {
  const textClass =
    userInputState === StatesUserInput.Record
      ? 'smallTimer'
      : 'smallTimer inactive-text';
  return (
    <div className="notchSafe timer-container">
      <div className="timer-text-container">
        <div className={textClass}>
          <span className="timerText">{msToTime(frames, 'seconds')}</span>
        </div>
        <div className={textClass}>
          <span className="timerText">{msToTime(frames, 'millis')}</span>
        </div>
      </div>
    </div>
  );
};

const TimerElement = ({
  frames,
  userInputState,
  videoActive,
}: TimerElementProps) => {
  if (videoActive) {
    return <SmallTimer frames={frames} userInputState={userInputState} />;
  }
  return <BigTimer frames={frames} userInputState={userInputState} />;
};

export default TimerElement;
